import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {fetchNestPolygons, Page} from "../../store/coreSlice";

const polygons = [];
const Nests = (props) => {
	useEffect(() => {
		if( !props.mapLoaded )
			return;

		if( props.page === Page.NESTS ) {
			if (props.nestPolygons)
				showNests();
			else
				props.fetchNestPolygons();
		} else if( props.page !== Page.NESTS && props.nestPolygons )
			hideNests();
	});

	const showNests = () => {
		if( !props.nestPolygons )
			return;

		console.log("Show nests - " + Object.keys(props.nestPolygons).length);

		for( let nestId of Object.keys(props.nestPolygons) ) {
			const data = props.nestPolygons[nestId];
			polygons[nestId] = new window.maps.Polygon({
				paths: data['polygon'],
				strokeColor: '#666666',
				strokeOpacity: 0.8,
				strokeWeight: 1,
				fillColor: '#ffff00',
				fillOpacity: 0.35
			});
			polygons[nestId].setVisible(true);
			polygons[nestId].setMap(window.map);
		}
	};

	const hideNests = () => {
		console.log("Hide nests");
		for( let nestId of Object.keys(props.nestPolygons) )
			polygons[nestId].setVisible(false);
	};

	return (
		<></>
	);
};

Nests.propTypes = {};

const mapStateToProps = (state) => {
	return {
		nestPolygons: state.core.nestPolygons,
		page: state.core.page,
		mapLoaded: state.core.mapLoaded
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchNestPolygons: () => dispatch(fetchNestPolygons())
		// NAME: (value) => dispatch(FN(value)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Nests);